import { useTranslation } from "next-i18next";

import Header from "../../text/header";
import { ChildArticles } from "../modules/child-articles";
import { HelpContactFooter } from "../modules/help-contact-footer";
import { HelpSearch } from "../modules/help-search";
import { HelpTopBanner } from "../top-banner/top-banner";
import { PublicArticle } from "../types/article";
import styles from "./landing.module.scss";

const SectionWrapper = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => {
    return <div className={`${styles.sectionWrapper} ${className}`}>{children}</div>;
};

type HelpPageType = {
    helpData: PublicArticle;
    type?: "consumer" | "merchant";
    hideContactUs?: boolean;
    articleToken?: string;
};

export const HelpPage = ({
    helpData,
    type = "consumer",
    hideContactUs,
    articleToken,
}: HelpPageType) => {
    const { t } = useTranslation();
    const title =
        type === "merchant" ? t("help.header.merchantTitle") : t("help.header.consumerTitle");

    return (
        <div className={styles.pageWrapper}>
            <SectionWrapper>
                <Header renderAs="h4" title={title} className={styles.helpTitle} />
            </SectionWrapper>
            <HelpSearch type={type} />
            <HelpTopBanner />
            <ChildArticles childArticles={helpData.childArticles} type={type} />
            {!hideContactUs && <HelpContactFooter type={type} articleToken={articleToken} />}
        </div>
    );
};
